import { useNavigate } from 'react-router-dom';
import { of } from 'rxjs';
import { catchError, map, take } from 'rxjs/operators';
import { EmailVerificationService } from '../../core/services/email-verification.service';
import useService from '../../injector/hooks/useService';

export function useEmailVerificationGuard() {
  const emailVerificationService = useService(EmailVerificationService);
  const navigate = useNavigate();

  const executeEmailVerificationGuard = () => {
    return emailVerificationService.emailVerified$.pipe(
      take(1),
      map((status) => {
        let allowNavigation = true;

        if (status.blocked) {
          allowNavigation = false;
        }

        if (!allowNavigation) {
          navigate('/verify-email-block');
        }

        return allowNavigation;
      }),
      catchError(() => {
        return of(true);
      })
    ).toPromise();
  };

  return {
    executeEmailVerificationGuard
  };
}
